module.exports = __webpack_public_path__ + "img/2017-03_bloomberg.b9171063.jpg";